import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranscriptionSaveEdit.meta';

export const useTrackTranscriptionSaveEdit = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranscriptionSaveEdit = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackTranscriptionSaveEdit };
};
